module.exports = __webpack_public_path__ + "assets/ce7924abcc534e7fd64bfbed774d2ae5.mp3";